import { fetchHelper } from '@price-point/http-helpers';
import _ from 'lodash';

export default async function hasInvalidInteraction(interaction) {
  if (!interaction) {
    return true;
  }

  try {
    const response = await fetchHelper('na', 'GET', `/api/v1/oidc/interactionCheck/${interaction}`);
    return !_.get(response, 'valid');
  } catch (ex) {
    return true;
  }
}
